import { HStack } from '@chakra-ui/react';
import React from 'react';
import CustomButton from '../CustomButton';

export type TTabButtonOption = {
  onClick: () => void;
  labelValue: string;
  labelDisplay: string;
};

interface Props {
  options: TTabButtonOption[];
  selectedOptionValue: string;
  minWidth?: string;
  padding?: string;
  tabHeight?: string;
  labelStyle?: React.CSSProperties;
}

const TabButtons = ({ options, selectedOptionValue, minWidth = '220px', padding, tabHeight, labelStyle }: Props) => {
  return (
    <HStack
      backgroundColor={'white'}
      padding={'5px'}
      borderRadius={'8px'}
      gap={'10px'}
      boxShadow={'0px 0px 12px 0px #00417926'}
    >
      {options.map((option) => (
        <CustomButton
          key={option.labelDisplay}
          label={option.labelDisplay}
          onClick={option.onClick}
          backgroundColor={selectedOptionValue === option.labelValue ? 'primary.500' : 'white'}
          labelColor={selectedOptionValue === option.labelValue ? 'white' : 'text.darkBlue'}
          isTransparent={selectedOptionValue !== option.labelValue}
          height={tabHeight}
          style={{ minWidth, padding, borderRadius: '6px' }}
          labelStyle={{ fontWeight: 800, ...labelStyle }}
          noShadow
        />
      ))}
    </HStack>
  );
};

export default TabButtons;
